import * as React from 'react';
import { APP_VERSION, BUGSNAG_FRONTEND_API_KEY } from '../../config/constants';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { isTransientNetworkError } from 'utils/bugsnagFilters';

const bugsnagClient = Bugsnag.start({
    apiKey: BUGSNAG_FRONTEND_API_KEY,
    appVersion: APP_VERSION,
    enabledReleaseStages: ['production'],
    plugins: [new BugsnagPluginReact(React)],
    releaseStage: process.env.NODE_ENV.toLowerCase() || 'test',
    onError: (event) => {
        // Returning false discards the event before it is sent.
        if (isTransientNetworkError(event.originalError)) return false;
    },
});

export default bugsnagClient;
